export default {
  global: {
    ok: 'Okay',
    accept: 'Accept',
    continue: 'Continue',
    cancel: 'Cancel',
    loading: 'Loading...',
  },
  vinculacioPage: {
    header: 'Link your\n idCAT Mobile',
    description:
      'To start using the application, log in with your idCAT Mobile ID. You only need to do this once.',
    button: 'Link idCAT Mobile',
  },
  userAlreadyExistsPage: {
    header: 'This idCAT Mobile ID is already in use on another device',
    description:
      'idCAT Mobile can only be linked to one mobile device. If you decide to link it to this device, it will be deactivated on the previous device.',
  },
  successPage: {
    header: 'Authentication successfully completed',
    description:
      'The identification document has been successfully verified with idCAT Mobile. You can now continue the process on the service website.',
  },
  onboardingFinish: {
    header: 'idCAT Mobile successfully linked to this device',
    description:
      'From now on, you can log in with idCAT Mobile to access Catalan public administration procedures by scanning the QR code or confirming the access request.',
    userFields: {
      name: 'Name',
      id: 'Identification document',
      phoneNumber: 'Mobile phone',
      device: 'Linked device',
    },
  },
  errors: {
    messageProcessing: {
      title: 'Error processing message',
      message: 'Could not process the message. Try again or contact support.',
    },
    invalidRequest: {
      title: 'Invalid request',
      message: 'Invalid request parameters. Please check and try again.',
    },
    authenticationFailed: {
      title: 'Authentication failed',
      message:
        'Your authentication attempt was unsuccessful. Try again or contact support.',
    },
    accessDenied: {
      title: 'Access denied',
      message:
        'You do not have permission to access this resource. Check credentials and try again.',
    },
    connectionError: {
      title: 'Connection error',
      message: 'Cannot connect to server. Check internet and try again.',
    },
    aocWalletUserError: {
      title: 'Connection Error',
      message:
        'An error occurred while trying to retrieve the wallet user. Please try again later.',
    },
    generalError: {
      title: 'Error',
      message: 'An unexpected error occurred. Try again or contact support.',
    },
  },
};
